import LoginIcon from "@mui/icons-material/Login";
import {
  Fab,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import theme from "#next/theme";
import { Link } from "#next/components/reusable/Link";
import { QuickSearchModal } from "#next/components/modals/QuickSearchModal";
import SearchIcon from "@mui/icons-material/Search";
import { SavedSearchList } from "#next/components/navigation/SavedSearch";
import { AdminOptionsList } from "#next/components/navigation/AdminOptions";

const fabStyle = {
  margin: 0,
  top: "auto",
  right: 40,
  bottom: 40,
  left: "auto",
  position: "fixed",
};

export function LeftSideNav({ onSelect }: { onSelect?: () => void }) {
  const [quickSearchModalIsOpen, setQuickSearchModalIsOpen] = useState(false);

  return (
    <>
      <Fab
        size="large"
        color="primary"
        aria-label="add"
        sx={fabStyle}
        onClick={() => setQuickSearchModalIsOpen(true)}
      >
        <SearchIcon />
      </Fab>
      <QuickSearchModal
        open={quickSearchModalIsOpen}
        onClose={() => setQuickSearchModalIsOpen(false)}
      />
      <Divider
        variant="middle"
        sx={{
          background: theme.palette.cyan.main,
        }}
      />
      <SavedSearchList onSelect={onSelect} />
      <AdminOptionsList />
    </>
  );
}

export function LoggedOutNav({ onSelect }: { onSelect?: () => void }) {
  return (
    <>
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
          flexGrow: 1,
        }}
      >
        <ListItem>
          <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
            <LoginIcon />
          </ListItemIcon>
          <ListItemText>
            <Link onClick={() => onSelect?.()} href="/api/auth/login">
              Login
            </Link>
          </ListItemText>
        </ListItem>
      </List>
    </>
  );
}
